document.addEventListener("DOMContentLoaded", function () {
  lazyImagesInit();
});

var lazyImagesInit = function () {
  var lazyImages = [].slice.call(
    document.querySelectorAll("img.lazyload[data-src]")
  );
  if ("IntersectionObserver" in window) {
    var lazyImageObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var lazyImage = entry.target;
            if (lazyImage.parentElement.id === 'historyCover') {
              setTimeout(function () {
                $("#historyCover").twentytwenty({
                  before_label: $("#historyCover").data("before").toString(),
                  after_label: $("#historyCover").data("after").toString()
                });
              }, 1000);
            }
            if (lazyImage.parentNode.classList.contains('person') && $('.row.analisisTop').length) {
              setTimeout(function () {
                $('.row.analisisTop').foundation('applyHeight', [1]);
              }, 1000);
            }
            lazyImage.src = lazyImage.dataset.src;
            if (lazyImage.dataset.srcset) {
              lazyImage.srcset = lazyImage.dataset.srcset
            }
            lazyImage.classList.remove("lazyload");
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      }, {
        rootMargin: "0px 0px 256px 0px"
      }
    );
    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    var active = false;
    var lazyLoad = function () {
      if (active === false) {
        active = true;

        setTimeout(function () {
          lazyImages.forEach(function (lazyImage) {
            if (
              lazyImage.getBoundingClientRect().top <= window.innerHeight &&
              lazyImage.getBoundingClientRect().bottom >= 0 &&
              getComputedStyle(lazyImage).display !== "none"
            ) {
              lazyImage.src = lazyImage.dataset.src;
              if (lazyImage.dataset.srcset) {
                lazyImage.srcset = lazyImage.dataset.srcset
              }
              lazyImage.classList.remove("lazyload");
              if (lazyImage.parentElement.id === 'historyCover') {
                setTimeout(function () {
                  $("#historyCover").twentytwenty({
                    before_label: $("#historyCover").data("before").toString(),
                    after_label: $("#historyCover").data("after").toString()
                  });
                }, 1000);
              }
              if (lazyImage.parentNode.classList.contains('person') && $('.row.analisisTop').length) {
                setTimeout(function () {
                  $('.row.analisisTop').foundation('applyHeight', [1]);
                }, 1000);
              }
              lazyImages = lazyImages.filter(function (image) {
                return image !== lazyImage;
              });

              if (lazyImages.length === 0) {
                document.removeEventListener("scroll", lazyLoad);
                window.removeEventListener("resize", lazyLoad);
                window.removeEventListener("orientationchange", lazyLoad);
              }
            }
          });

          active = false;
        }, 200);
      }
    };

    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);
    lazyLoad();
  }
};